<template>
  <input class="form-control" :value="defaultDate ? defaultDate : null"/>
</template>

<script>
  export default {
    props: [ 'dateFormat', 'defaultDate' ],
    mounted: function() {
      const self = this;
      $(this.$el).datepicker({
        format: this.dateFormat,
        weekStart: 1,
        todayHighlight: true,
      }).on('changeDate', e => {
          $(this.$el).datepicker('hide');
          this.$emit('dateSelected', e.target.value)
        });
    },
    beforeDestroy: function() {
      $(this.$el).datepicker('hide').datepicker('destroy');
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/partials/Datepicker.vue